import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PrivateCoachingCard = ({ name, text, image_url, showPopup }) => {
  return (
    <div className="PrivateCoaching__card">
      <div className="PrivateCoaching__card-image-block">
        <LazyLoadImage
          className="PrivateCoaching__card-image-element"
          src={image_url}
          alt="PrivateCoaching__card-image"
        />
      </div>
      <div className="PrivateCoaching__card-description">
        <h3 className="PrivateCoaching__card-description-title">{name}</h3>
        <p className="PrivateCoaching__card-description-subtitle">{text}</p>
        <div className="PrivateCoaching__card-description-options">
          <div className="PrivateCoaching__card-description-box">
            <div
              onClick={showPopup}
              className="PrivateCoaching__card-description-form"
            >
              Review Coaching Options
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivateCoachingCard;
